import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import * as CONSTANTS from "../constants";
import ErrorAlert from "./common/ErrorAlert";

import CheckBoxRadioInput from "./common/CheckBoxRadioInput";

import ForgotAccountCommon from "./ForgotAccountCommon";
import ReCAPTCHA from "react-google-recaptcha";

class ForgotUserName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {recaptcha: ""},
      loading: false,
      username: "",
      userType: CONSTANTS.USER_TYPE_INDIVIDUAL,
      showForm: false,
      genericError: null,
    };
    // console.log("🚀 ~ file: ForgotUserName.js ~ line 112 ~ ForgotUserName ~ render ~ this.props.clientId", this.props.clientId);
    // console.log("🚀 ~ file: ForgotUserName.js ~ line 112 ~ ForgotUserName ~ render ~ this.props.clientInfo", this.props.clientInfo);
    // console.log("🚀 ~ file: ForgotUserName.js ~ line 112 ~ ForgotUserName ~ render ~ this.props.isThirdParty", this.props.isThirdParty);
  }
  handaleSubmit = async (e) => {
    e.preventDefault();
    console.log("userType => " + this.state.userType);
    if(CONSTANTS.USER_TYPE_INDIVIDUAL === this.state.userType || CONSTANTS.USER_TYPE_NON_MOBILY === this.state.userType){
        console.log("Individual or non-Mobily account selected");
        const redirectUrl =window.MOBILE_APP_URL;
        console.log("CONSUMER userType URL::"+redirectUrl);
        window.location.replace(redirectUrl);
    }
    this.setState({
      // loading: true,
      showForm: true,
      userType: this.state.userType,
    });
  };

  handleChange = async (e) => {
    // console.log(" => handleChange => Enter " + e.target.value);
    // console.log(" => handleChange => Enter  " + e.target.name);
    e.persist();
    // this.setState({ formIsValid: true });
    this.setState({
      [e.target.name]: e.target.value,
    });

    // CHECK USERNAME VALIDITY
    /*if (e.target.name === 'userName'){
          await this.verifyUsername(e.target.value)        
      }*/
  };
  render() {
    const { t } = this.props;
    const { loading } = this.state;

    return (
      <div>
        {this.state.genericError && <ErrorAlert error={this.state.genericError} />}
        {!this.state.showForm ? (
          <form id="forgot-username-form" onSubmit={this.handaleSubmit}>
            <CheckBoxRadioInput
              label={"individual_account"}
              name={"userType"}
              value={CONSTANTS.USER_TYPE_INDIVIDUAL}
              type={"radio"}
              handleChange={this.handleChange}
              checked={this.state.userType === CONSTANTS.USER_TYPE_INDIVIDUAL}
              disabled={this.props.isThirdParty && this.props.clientInfo[CONSTANTS.USER_TYPE_INDIVIDUAL] != 'Y' ? true : false}
              singleLine={false}
              render={true}
            />
            <CheckBoxRadioInput
              label={"corporate_account"}
              name={"userType"}
              value={CONSTANTS.USER_TYPE_CORPORATE}
              type={"radio"}
              handleChange={this.handleChange}
              checked={this.state.userType === CONSTANTS.USER_TYPE_CORPORATE}
              disabled={this.props.isThirdParty && this.props.clientInfo[CONSTANTS.USER_TYPE_CORPORATE] != 'Y' ? true : false}
              singleLine={false}
              render={true}
            />
            <CheckBoxRadioInput
              label={"none_mobily"}
              name={"userType"}
              value={CONSTANTS.USER_TYPE_NON_MOBILY}
              type={"radio"}
              handleChange={this.handleChange}
              checked={this.state.userType === CONSTANTS.USER_TYPE_NON_MOBILY}
              disabled={this.props.isThirdParty && this.props.clientInfo[CONSTANTS.USER_TYPE_CORPORATE] != 'Y' ? true : false}
              singleLine={false}
              render={true}
            />
             <ReCAPTCHA ref={this.recaptchaRef}
                    className="mt-4"
                    sitekey="6LfrHxQUAAAAALYsoGKjq19qYqszOqtMmUicDO2p"
                    type="image"
                    hl={window.lang === 'ar' ? "ar" : "en"}
                    name={"recaptcha"}
                />{this.state.errors.recaptcha &&
                    <ErrorAlert error={this.state.errors.recaptcha} />
                  }
            <button
              id="forgot-username-submit-btn"
              type="submit"
              className="mt-4 btn min_outlin_btn active"
              disabled={this.props.isThirdParty
                && (this.props.clientInfo[CONSTANTS.USER_TYPE_INDIVIDUAL] != 'Y' ||
                  this.props.clientInfo[CONSTANTS.USER_TYPE_CORPORATE] != 'Y' ||
                  this.props.clientInfo[CONSTANTS.USER_TYPE_NON_MOBILY] != 'Y')}
            >
              {t("next_btn")}{" "}
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </form>
        ) : (
            <ForgotAccountCommon
              formType={CONSTANTS.FORM_TYPE_FORGOT_USERNAME}
              userType={this.state.userType}
              // submitAction={this.handaleSubmit}
              setShowSuccessMsg={this.props.setShowSuccessMsg}
              setMessageDetails={this.props.setMessageDetails}
              sendBy={[this.state.userType != CONSTANTS.USER_TYPE_CORPORATE ? "Email" : "", this.state.userType != CONSTANTS.USER_TYPE_NON_MOBILY ? "SMS" : ""]}
              clientId={this.props.clientId}
              redirectURL={this.props.redirectURL}
              clientInfo={this.props.clientInfo}
              isThirdParty={this.props.isThirdParty}
              isConsumer={this.props.isConsumer}
            />
          )}
        {loading ? <div className="loading">Loading&#8230;</div> : null}
      </div>
    );
  }
}
export default withTranslation()(ForgotUserName);
